// Handle color swatch clicks on product cards in recommendations
(function () {
  function onSwatchClick(e) {
    const swatch = e.target.closest('.card-swatch');
    if (!swatch) return;
    const card = swatch.closest('.card-product-custom');
    if (!card) return;
    // Toggle selected state
    card.querySelectorAll('.card-swatch').forEach((btn) => {
      btn.classList.remove('is-selected');
      btn.setAttribute('aria-pressed', 'false');
    });
    swatch.classList.add('is-selected');
    swatch.setAttribute('aria-pressed', 'true');
    card.classList.add('variant-is-selected');
    // Update image
    const img = card.querySelector('.card-product-custom__image');
    if (img) {
      const newSrc = swatch.getAttribute('data-image-src');
      const newSrcset = swatch.getAttribute('data-image-srcset');
      const newAlt = swatch.getAttribute('data-image-alt') || img.getAttribute('alt') || '';
      if (newSrcset) img.setAttribute('srcset', newSrcset);
      if (newSrc) img.setAttribute('src', newSrc);
      img.setAttribute('alt', newAlt);
    }
    // Update hidden variant input
    const variantId = swatch.getAttribute('data-variant-id');
    const form = card.querySelector('product-form form');
    const idInput = form && form.querySelector('input[name="id"]');
    if (idInput) idInput.value = variantId;
    // Update button state
    const available = swatch.getAttribute('data-available') === 'true';
    const submit = form && form.querySelector('button[type="submit"]');
    if (submit) {
      if (available) {
        submit.removeAttribute('disabled');
        const label = submit.querySelector('span');
        if (label) label.textContent = window.variantStrings?.addToCart || 'Add to cart';
      } else {
        submit.setAttribute('disabled', 'disabled');
        const label = submit.querySelector('span');
        if (label) label.textContent = window.variantStrings?.soldOut || 'Sold out';
      }
    }
  }
  document.addEventListener('click', onSwatchClick);
})();